import React from 'react'
import { ContentProps } from '@components/renderer'
import { TypeAssetPdf } from '@lib/types/asset-pdf'

import styles from './pdf.module.scss'

export const PDFAsset: React.FC<ContentProps<TypeAssetPdf>> = (props) => {
  const { structure } = props
  const { asset, showNavPanel, showToolbar, height } = structure.fields || {}

  if (!asset || !asset.fields?.file?.url) {
    return null
  }

  const { url } = asset.fields.file

  const pdfUrl = `${url}#toolbar=${+showToolbar}&navpanes=${+showNavPanel}&scrollbar=1&view=FitH`

  return <iframe className={styles.pdfIframe} style={{ height }} src={pdfUrl} />
}
